import React from "react";
import { IconButton } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { API } from "../../../../../shared/services";
import { useContacts, useContactsState } from "../../../contexts/contact/hook";
import starIcon from "../../../assets/icons/star.svg";
import starCheckedIcon from "../../../assets/icons/star-checked.svg";

export default function FavoriteAction() {
  const { t } = useTranslation("common");
  const { updateCurrentContact } = useContacts();
  const { currentContact } = useContactsState();

  function handleClick() {
    API.put(`customers/${currentContact.id}`, {
      customer: {
        is_favorite: !currentContact.is_favorite,
      },
    })
      .then(() => {
        updateCurrentContact({
          ...currentContact,
          is_favorite: !currentContact.is_favorite,
        });

        toast.success(t("success"));
      })
      .catch(() => toast.error(t("error")));
  }

  return (
    <IconButton onClick={handleClick}>
      <img
        width={27}
        height={27}
        src={currentContact.is_favorite ? starCheckedIcon : starIcon}
      />
    </IconButton>
  );
}
